import { isNull } from 'lodash'

import constants from 'constants/index'

const checkDefault = (profile) => {
  if (
    profile?.profileType === constants.profile.PROFILE_TYPE_CLIENT ||
    profile?.profileType === constants.profile.PROFILE_TYPE_ADVISOR
  ) {
    if (
      profile?.default === constants.profile.DEFAULT_TRUE &&
      profile?.company === null &&
      profile?.organization === null
    ) {
      return 'Perfil sugerido'
    }

    if (!isNull(profile?.company)) {
      return 'Perfil de empresa'
    }

    return 'Perfil de grupo advisor'
  }
}

export default checkDefault
